<template>
  <div>
    <panel :title="$t('studentScoringEntry.studentList')">
      <ts-loading-banner :loading="loading">
        <div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>{{ $t('studentScoringEntry.photo') }}</th>
                <th>{{ $t('studentScoringEntry.cardNumber') }}</th>
                <th>{{ $t('studentScoringEntry.studentName') }}</th>
                <th>{{ $t('studentScoringEntry.sex') }}</th>
                <th>{{ $t('studentScoringEntry.phoneNumber') }}</th>
                <th style="width:10px">{{ $t('actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in student_list" :key="index">
                <td class="with-img">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(student.student_profile),
                      error: onError(student.student_profile),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </td>
                <td>{{ student.student_profile.card_number }}</td>
                <td>{{ student.student_profile.full_name_en }}</td>
                <td>{{ student.student_profile.gender }}</td>
                <td>{{ student.student_profile.phone }}</td>
                <td class="text-center d-flex">
                  <a
                    href="#"
                    class="mr-2 btn btn-xs btn-primary"
                    v-if="allowInput"
                    v-tooltip="$t('studentScoringEntry.entryScore')"
                    @click.prevent="entryScore(student)"
                  >
                    <i class="fas fa-pen"></i>
                  </a>
                  <a
                    href="#"
                    class="btn btn-xs btn-primary"
                    @click.prevent="onAdvisorComment(student)"
                    v-tooltip="$t('studentScoringEntry.comment')"
                  >
                    <i class="fas fa-comment-alt"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- numeric scoring entry -->
          <a-modal
            v-if="numeric_scoring"
            v-model="numeric_scoring"
            :zIndex="1020"
            :title="entry_on_student"
            :maskClosable="false"
            width="700px"
            :footer="null"
          >
            <numeric-scoring-entry
              v-model="model"
              @closeModal="() => (numeric_scoring = false)"
            />
          </a-modal>
          <!-- grading scoring entry -->
          <a-modal
            v-if="grading_scoring"
            v-model="grading_scoring"
            :zIndex="1020"
            :title="entry_on_student"
            :maskClosable="false"
            width="700px"
            :footer="null"
          >
            <grading-scoring-entry
              v-model="model"
              @closeModal="() => (grading_scoring = false)"
              :params-get-component="paramsGetComponentForGrading"
            />
          </a-modal>
          <!-- advisor comment -->
          <a-modal
            v-if="advisor_comment"
            v-model="advisor_comment"
            :zIndex="1020"
            :title="entry_on_student"
            :maskClosable="false"
            width="400px"
            :footer="null"
          >
            <advisor-comment
              v-model="model"
              @closeModal="() => (advisor_comment = false)"
            />
          </a-modal>
        </div>
      </ts-loading-banner>
    </panel>
  </div>
</template>

<script>
import GradingScoringEntry from './grading-score-entry'
import NumericScoringEntry from './numeric-score-entry'
import AdvisorComment from './advisor-comment'

export default {
  name: 'studentListComponent',
  props: ['value'],
  components: {
    GradingScoringEntry,
    NumericScoringEntry,
    AdvisorComment
  },
  data () {
    return {
      paramsGetComponentForGrading: {
        grade_id: 0,
        sc_bas_id: null
      },
      model: {},
      loading: false,
      numeric_scoring: false,
      grading_scoring: false,
      advisor_comment: false,
      param_props: [],
      student_list: [],
      boyPhoto: require('../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../assets/student-default-girl.png'),
      entry_on_student: 'Unknow'
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    allowInput () {
      return (
        this.model.class_id !== null &&
        this.model.scoring_cycle_id !== null &&
        this.model.cycle_value !== null
      )
    }
  },
  methods: {
    fetchStudentListHasEnroll (class_id) {
      this.student_list = []
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/getStudentEnrollmentByClass', class_id)
        .then(response => {
          this.student_list = _.orderBy(response.data, [
            'student_profile.card_number'
          ])
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    photoStudent (record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onError (record) {
      event
        ? (event.target.src =
            record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    entryScore (record) {
      var sc_bas_id = 1 // default is item base
      var scoring_cycle = this.model.scoring_cycle_id

      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      this.model.sc_subject_id = record.academic_class.subject_id
      if (record.academic_class.grade.score_type == 1) {
        // entry score for numberic
        if (scoring_cycle == 1) {
          sc_bas_id = record.academic_class.grade.monthly_score_sc_bas_id
        } else if (scoring_cycle == 2) {
          sc_bas_id = record.academic_class.grade.semester_score_sc_bas_id
        }

        this.numeric_scoring = true
        this.model.score_type = 1
        this.model.sc_bas_id = sc_bas_id
      } else if (record.academic_class.grade.score_type == 2) {
        // entry score for grading
        this.paramsGetComponentForGrading.grade_id =
          record.academic_class.grade.grade_id

        if (scoring_cycle == 1) {
          sc_bas_id = record.academic_class.grade.monthly_score_sc_bas_id
        } else if (scoring_cycle == 2) {
          sc_bas_id = record.academic_class.grade.semester_score_sc_bas_id
        }

        this.paramsGetComponentForGrading.sc_bas_id = sc_bas_id

        this.grading_scoring = true
        this.model.score_type = 2
      }
    },
    onAdvisorComment (record) {
      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      this.advisor_comment = true
    }
  },
  watch: {
    'model.class_id': function (id) {
      if (id) {
        this.fetchStudentListHasEnroll(id)
      }
    }
  }
}
</script>
